import React, { useState } from 'react';

const FileUploadBeforeShipment = ({ onFileReadyForUpload }) => {
  const [uploadStatus, setUploadStatus] = useState('');

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (file && (file.type === 'application/pdf' || file.type.startsWith('image/'))) {
      onFileReadyForUpload(file); // Send file to parent
      setUploadStatus('File selected. Will upload after shipment is created.');
    } else {
      setUploadStatus('Only PDF or image files are allowed');
    }
  };

  return (
    <div style={{ borderRadius: '8px' }}>
      <label
        style={{
          display: 'block',
          marginBottom: '10px',
          marginTop: '10px',
          color: 'yellow'
        }}
      >
        Type: PDF/Image
      </label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="file"
          onChange={handleFileChange}
          accept="application/pdf,image/*"
          style={{
            display: 'inline-block',
            padding: '5px',
            color: '#fff',
            borderRadius: '4px',
            border: '1px solid #666',
            background: '#555',
            width: '95%'
          }}
        />
      </div>
      {uploadStatus && <p style={{ color: '#32CD32', marginTop: '10px' }}>{uploadStatus}</p>}
    </div>
  );
};

export default FileUploadBeforeShipment;
